export enum AddonCategory {
  EXTERNAL_STORAGE_SERVICES = 'external-storage-services',
  EXTERNAL_CITATION_SERVICES = 'external-citation-services',
  EXTERNAL_LINK_SERVICES = 'external-link-services',
  EXTERNAL_REDIRECT_SERVICES = 'external-redirect-services',
}
